import React, { useEffect, useState } from 'react';
import { ICartItem, ICartItemPrices } from '../../../interfaces';

interface ICartItemPromos {
    cartItem: ICartItem,
    classes?: string,
}

/**
 * combine promos string from coupon and upsell
 */
const getPromos = (cartItemPriceData: ICartItemPrices) => {
    const promos = [];

    if(cartItemPriceData.appliedCoupons){
        promos.push(...cartItemPriceData.appliedCoupons);
    }

    if(cartItemPriceData.showInstantSavings){
        promos.push('Instant Savings');
    }

    return promos.join(', ');
};

const CartItemPromos = (props: ICartItemPromos) => {

    const cartItem = props.cartItem;
    const cartItemPriceData = cartItem.priceData;

    const [promos, setPromos] = useState('');

    /**
     * init promos string
     */
    useEffect(() => {
        setPromos(getPromos(cartItemPriceData));
    }, [cartItemPriceData]);

    return (
        promos ?
        <div className={`flex items-center text-green mb-2 ${ props.classes ? props.classes : '' }`}>
            Promos: { promos }
        </div> : <></>
    )
};

export default CartItemPromos;